import React from 'react';
import './Hero.css'; // Importamos los estilos específicos para este componente

const Hero = () => {
  return (
    <section id="inicio" className="hero-section d-flex align-items-center text-center">
      <div className="container">
        <h1 className="display-3 text-white fw-bold">Impulsamos tu marca con Marketing, Fotografía y Tecnología</h1>
        <p className="lead text-white-50 mx-auto" style={{ maxWidth: '700px' }}>Agencia integral en fotografía, producción audiovisual, diseño web, SEO y CRM.</p>
        <p>
          <a href="#" className="btn btn-primary btn-lg mt-3">Solicita asesoría gratuita</a>
        </p>
      </div>
    </section>
  );
};

export default Hero;
